export const firstSectionSpacing = {
  xs: 16,
  md: 22,
  xl: 28,
}
